import { render, staticRenderFns } from "./politicasComerciales.vue?vue&type=template&id=6b20c1f0"
import script from "./politicasComerciales.vue?vue&type=script&lang=js"
export * from "./politicasComerciales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports